var _excluded = ["disabled", "underline"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Link as MuiLink, styled } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Root = styled(MuiLink, {
  label: 'MnrlLink-root'
})(function (_ref) {
  var disabled = _ref.ownerState.disabled,
      theme = _ref.theme;
  return disabled ? {
    color: theme.palette.text.disabled
  } : {};
});
export var Link = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var disabled = _ref2.disabled,
      underline = _ref2.underline,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/_jsx(Root, _extends({
    ownerState: {
      disabled: disabled
    }
  }, restProps, disabled ? {
    'aria-disabled': true,
    component: 'span',
    href: undefined,
    underline: 'none'
  } : {
    underline: underline
  }, {
    ref: ref
  }));
});